<template>
  <div class="container linked-tags">
    <div v-if="linkedError" class="error-message">{{linkedError}}</div>
    <div v-else-if="!linkedTags || !linkedTags.length" class="empty-response">no linked tags</div>
    <div v-else class="table-wrapper">
      <table>
        <thead>
          <th></th>
          <th>brand tag</th>
          <th>retailer</th>
          <th class="hide-for-small">state</th>
          <th>confirmed</th>
        </thead>
        <tbody>
          <tr v-for="tag in linkedTags" :key="tag.id">
            <td>
              <div class="delete-link" @click="$emit('showConfirmModal', tag.id, tag.name, tag.retailer)">x</div>
            </td>
            <td>{{tag.name}}</td>
            <td>{{tag.retailer}}</td>
            <td class="hide-for-small">{{tag.state}}</td>
            <td>
              <div :class="['checkmark', { unconfirmed: tag.status === 0 }]">
                <div :class="['check', { confirmed: tag.status === 1 }]"></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination
        v-if="totalPageCount && totalPageCount > 1"
        :currentPage="currentPage"
        :totalPageCount="totalPageCount"
        showArrows
        @changePage="changePage">
    </pagination>

  </div>
</template>

<script>
  import Pagination from '../Shared/Pagination'

  export default {
    props: {
      currentPage: Number,
      linkedError: String,
      linkedTags: Array,
      totalPageCount: Number,
    },

    name: 'LinkedTags',

    components: {
      Pagination,
    },

    methods: {
      changePage(page) {
        this.$emit('changePage', page)
      }
    },

    watch: {
      currentPage: function() {
        this.$emit('changePage', this.currentPage)
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.linked-tags
  .table-wrapper
    margin-top: .5rem
    max-height: 600px
    overflow-y: scroll
    padding-right: .25rem
    @media only screen and (max-width: 64em)
      display: flex
      justify-content: center

  table
    margin: 0 auto
    width: 90%

    th:nth-child(2), td:nth-child(2)
      text-align: left

    th:first-child, td:first-child
      padding: 0
      width: 6%

    th:last-child, td:last-child
      text-align: center

    th, td
      line-height: 125%
      width: 23%
      
    th
      background: white
      padding: 0 .5rem .5rem .5rem
      position: sticky
      top: 0

    td
      padding: .5rem

  .checkmark
    display: flex
    height: 16px
    margin: auto
    width: 16px     

    &.unconfirmed
      background-color: $primary-transparent

  .check
    display: none
    height: 9px
    margin-top: -3px

    &.confirmed
      display: flex
</style>

